import { Link } from "react-router-dom";
import React from 'react';
const Activiteitensidebar = ({token, username, isActive, onToggle}) => {
  if (username.bedrijf && username.bedrijf.modules.includes("activiteiten")) {
    if (
      token.role === "admin" ||
      token.role === "manager"
    ) {
      return (
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon">
              <i className="fa fa-book"></i>
            </span>
            <span className="menu-text">Activiteiten</span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}>
              <i className="fas fa-chevron-right"></i>
            </span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>
            <div className="menu-item">
              <Link to="/activiteiten" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-book"></i>
                </span>
                <span className="menu-text">Activiteiten met inschrijving</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/activiteiten/show/all" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-book"></i>
                </span>
                <span className="menu-text">Alle Activiteiten</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/activiteiten/insert/website" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-book"></i>
                </span>
                <span className="menu-text">Toevoegen Website</span>
              </Link>
            </div>
          </div>
        </div>
      );
    } else {
      return null
    }
  } else {
    return null
  }
  };
  export default Activiteitensidebar